import { Component, OnChanges, input, model } from '@angular/core';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-view-skills',
    templateUrl: './view-skills.component.html',
    styleUrl: './view-skills.component.scss',
    standalone: false
})
export class ViewSkillsComponent implements OnChanges {
  faEdit = faEdit;
  edit_skills = model<boolean>();
  user = input<any>();
  editable = input.required<boolean>();
  skills_list: any;
  skills_list_advisors: any;
  skillIdMap = new Map<number, any>(); // Map skill_ids to skill objects which are shown
  gaccText: string = '--';

  constructor(
    private readonly userService: UserService,
  ) {
    this.userService.getSkillList().subscribe((skills) => {
      skills.forEach((item: any) => {
        this.skillIdMap.set(item.value, item)
      })
      this.skills_list = skills.filter((skill: any) => skill.value <= 19 && skill.value != 14);
      this.skills_list_advisors = skills.filter((skill: any) => skill.value >= 20);
    })
  }

  ngOnChanges() {
    if((this.user().GACC_dispatch_center_id ?? -1) != -1) {
    this.userService.getGACCList().subscribe((gaccList) => {
      let gaccItem = gaccList.find((gaccItem: any) => gaccItem.value == this.user().GACC_dispatch_center_id);
      this.gaccText = gaccItem.text + ' - ' + gaccItem.description;
    })
    } 
    this.skillIdMap.forEach((skill: any) => {
      skill.experience = '--';
    });
    if (this.skills_list && this.user()) {
      this.user().skills.forEach((skill: any) => {
        // Setting the experience on object in the skills list to display current user
        this.skillIdMap.get(skill.skill_id).experience = skill.experience.text.replace(' assignments', '');
      });
    }

    this.skills_list.forEach((skill: any) => {
      skill.text = skill.text.replaceAll('_', ' ').replaceAll(/(^\w|\s\w)/g, (m: string) => m.toUpperCase());
    })
  }

  edit() {
    this.edit_skills.update((x) => {
      return true;
    });
  }
}
